module.exports = __webpack_public_path__ + "img/liuhuang-qrcode.ec1081b6.png";